import Layout from "../../layout/main";
import WithdrawWallet from "../../components/withdrawWallet";
/**
 * WithdrawWalletPage
 *
 * صفحه درخواست برداشت از کیف پول.
 * رندر کامپوننت WithdrawWallet داخل لایه اصلی Layout برای مدیریت و ثبت درخواست برداشت.
 *
 * @returns JSX.Element
 */
const WithdrawWalletPage = () => {
  return (
    <Layout>
      <WithdrawWallet />
    </Layout>
  );
};

export default WithdrawWalletPage;
